export type OperationCompletion = {
  id: number;
  title: string;
  message: string;
};

type OperationCompletionInput = Partial<Pick<OperationCompletion, "title" | "message">>;
type Listener = (completion: OperationCompletion) => void;

const listeners = new Set<Listener>();
let nextId = 1;

export function notifyOperationCompleted(input: OperationCompletionInput = {}) {
  const completion: OperationCompletion = {
    id: nextId++,
    title: input.title ?? "已完成",
    message: input.message ?? "数据已保存并同步，无需重复操作。",
  };

  listeners.forEach((listener) => listener(completion));
}

export function subscribeToOperationCompletions(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
